export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/technical_writing.a4e6300.svg";